import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { NotFoundError } from 'commons/errors'
import { Request } from 'commons/utils/request/request'

export const createCompanyRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `create`,
    loader: () => Request.post(Request.urls.bank.companyCreateMode),
    component: lazyRouteComponent(() => import('./ManageCompany'))
  })

export const editCompanyRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `edit/$companyId`,
    loader: async ({ params }) => {
      if ('companyId' in params) return Request.post(Request.urls.bank.companyEditMode, { id: +params.companyId })
      else throw new NotFoundError()
    },
    component: lazyRouteComponent(() => import('./ManageCompany')),
    gcTime: 0
  })
